var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.pnpm/@angular-devkit+build-angular@21.2.15_3b50c54796ac790e06c5f93268bf2629/node_modules/@angular-devkit/build-angular/src/tools/babel/webpack-loader.js??ruleSet[1].rules[2].use[0]!./node_modules/.pnpm/@ngtools+webpack@21.2.15_@angular+compiler-cli@21.2.17_@angular+compiler@21.2.17_typesc_2a6c46ad7827c82e4ea42c141c9cc9d2/node_modules/@ngtools/webpack/src/ivy/index.js!./node_modules/.pnpm/source-map-loader@5.0.0_webpack@5.105.2_@swc+core@1.15.24_@swc+helpers@0.5.21__esbuild@0.28.1_/node_modules/source-map-loader/dist/cjs.js??ruleSet[1].rules[3]!./node_modules/.federation/entry.246f94e9c05e8b6e1a4365b90dd609fb.js */ 45328);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};